import React from 'react';
import { useTranslation } from 'react-i18next';
import type { PapiNetworkbarStrip } from '@wix/da-papi-types';
import DeviationShopCard from '@wix/da-shared-react/pkg/ShopCard/DeviationShopCard';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import { Url } from '@wix/da-url';
import TitledStrip, { cardWidth } from '../../_partials/TitledStrip';

interface Props {
  strip: PapiNetworkbarStrip;
  className?: string;
}

const RecommendedSellStrip: React.FC<Props> = ({ strip, className }) => {
  const { t } = useTranslation();

  return (
    <TitledStrip
      title={t('shopPage.sellYourArt.strips.recommendedSellStrip.heading')}
      description={t(
        'shopPage.sellYourArt.strips.recommendedSellStrip.description'
      )}
      className={className}
    >
      {strip.deviations &&
        strip.deviations.map(deviation => (
          <DeviationShopCard
            key={deviation.deviationId}
            deviation={deviation}
            width={cardWidth}
            detailsRightSlot={
              <BuyButton
                size="large"
                rounded
                href={Url.deviationLink(deviation.deviationId)}
              >
                {t(
                  'shopPage.sellYourArt.strips.recommendedSellStrip.sellButton.label'
                )}
              </BuyButton>
            }
          />
        ))}
    </TitledStrip>
  );
};

RecommendedSellStrip.displayName = 'RecommendedSellStrip';

export default RecommendedSellStrip;
